import { render, staticRenderFns } from "./v-pills-list.vue?vue&type=template&id=72d153e8&scoped=true"
import script from "./v-pills-list.vue?vue&type=script&lang=js"
export * from "./v-pills-list.vue?vue&type=script&lang=js"
import style0 from "./v-pills-list.vue?vue&type=style&index=0&id=72d153e8&prod&lang=scss&scoped=true"
import style1 from "./v-pills-list.vue?vue&type=style&index=1&id=72d153e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d153e8",
  null
  
)

export default component.exports